import React from 'react';
import App from './app/Application';
import { createRoot } from 'react-dom/client';
import 'assets/styles/main.scss';
const domNode = document.getElementById('root');
const root = createRoot(domNode);
root.render(React.createElement(App, null));
